import { SubscriptionTag as SubscriptionTagModel } from '@models/membership/SubscriptionTag'
import { useAppSelector } from '@store/hooks'
import { selectSubscriptionTagById } from '@store/membership/SubscriptionTagReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { FC } from 'react'

type Props = SBModelComponent<SubscriptionTagModel> & {}

const SubscriptionTagOption: FC<Props> = ({ id, model }) => {
  const item = model ? model : useAppSelector(selectSubscriptionTagById(id!))

  if (!item) {
    return <></>
  }

  return item.name
}

type SubscriptionTagOptionType = {
  Option: typeof SubscriptionTagOption
}

export { SubscriptionTagOption, type SubscriptionTagOptionType }
